import "./BaseSelect";

NS("UI.Widget.Forms.Control");

UI.Widget.Forms.Control.EnumSelect = Class(UI.Widget.Forms.Control.BaseSelect, {
    prepareItems: function () {
        var enumClass;
        eval("enumClass = " + this.$control.attr("enum") + ";");

        var items = {};

        enumClass.each(function (value) {
            items[value] = enumClass.title(value);
        });

        return items;
    }
});
